// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iGVXo","colBig":"styles_colBig__1YjeQ","colSmall":"styles_colSmall__3FX1J","shopifyNameWrapper":"styles_shopifyNameWrapper__3xQOb"};